import React from 'react';
import {MainBannerStyled} from "../../styled/HomeContent";
import { HiPaperAirplane } from "react-icons/hi2";
import {Link} from "react-router-dom";
import IconButtonStyled from "../../styled/IconButton";
// import Button from "../UI/Buttons/Button";
import Typewriter from "typewriter-effect";
// import {AltButtonsStyled} from "../../styled/Buttons";
// import analyticsTracker from "../../utils/analytics";




const MainBanner = ({start, isAuth}) => {
    // const resumeLink = isAuth ? '/user/dashboard/resume' : '/popin?resume';
    // const mockLink = isAuth ? '/user/dashboard/mock' : '/popin?mock';
    // const jobHubLink = isAuth ? '/user/dashboard/job-hub' : '/popin?job-hub';

    // const handleServiceClick = (serviceName, serviceUrl) => () => {
    //     try { analyticsTracker.trackServiceClick(serviceName, serviceUrl); } catch (e) { /* noop */ }
    // };

    return (
        <MainBannerStyled>
            <div className='auto-type'>
                <Typewriter
                    options={{
                        strings: [
                            "CareerTech Super-Human Intelligence.",
                            "Your AI Career Copilot.",
                            "Supercharge your Career.",
                            "Understand Today's Insights.",
                            "Guarantee Tomorrow's Success."
                        ],
                        autoStart: true,
                        loop: true,
                    }}
                />
            </div>
            <p>Ask me anything</p>
            <div className="search" onClick={start}>
                <input type="search" onFocus={start} name="search" id="search" placeholder="Type here...."/>
                <IconButtonStyled $bg='#000' fontSize='0.9rem' $pad='0.3rem'>
                    <HiPaperAirplane />
                </IconButtonStyled>
            </div>

            {/* <div className="desktopbtns">
                <Button link={resumeLink} color='#fff' title='Resume Assistant' secondary={true} clickHandle={handleServiceClick('Resume Assistant', resumeLink)}/>
                <Button link={mockLink} color='#fff' title='Take Live Mock Exam' secondary={true} clickHandle={handleServiceClick('Take Live Mock Exam', mockLink)}/>
                <Button link={jobHubLink} color='#fff' title='Automate Job Application' secondary={true} clickHandle={handleServiceClick('Automate Job Application', jobHubLink)}/>
            </div> */}

            <Link to='/privacy' className="privacy">Privacy Policy</Link>
        </MainBannerStyled>

    );
}

export default MainBanner;